import React, { useEffect, useState, useContext } from "react";
import { Button, Classes, Dialog, HTMLTable, Intent } from "@blueprintjs/core";

import { datetimeFormatter } from "../../utils/dates";
import { StoresContext } from "../../pages/_app";
import { GenomePublicationChange } from "../../api";

interface Props {
  genomeUuid: string;
  genomeCreatedAt: string;
  isOpen: boolean;
  close: () => void;
}

export function PublicationHistoryPopup(props: Props) {
  const rootStore = useContext(StoresContext);
  const [history, setHistory] = useState<GenomePublicationChange[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props.isOpen) {
      (async () => {
        setLoading(true);
        const history = await rootStore.genomeStore.fetchHistory(props.genomeUuid);
        // To keep things consistent with the backend internals, we replace the first date by the genome.created_at
        history[0] = { date: props.genomeCreatedAt };
        setHistory(history);
        setLoading(false);
      })();
    } else {
      setHistory([]);
    }
  }, [props.genomeUuid, props.isOpen]);

  let body: React.ReactNode = (
    <>
      <tr>
        <td>
          <span className="bp4-skeleton">Published</span>
        </td>
        <td>
          <span className="bp4-skeleton">February 27, 2023</span>
        </td>
      </tr>
    </>
  );
  if (!loading) {
    body = history.map((ev, i) => {
      return (
        <tr key={i}>
          <td>{i === 0 ? "Published" : "Updated"}</td>
          <td>{datetimeFormatter(ev.date)}</td>
        </tr>
      );
    });
  }

  return (
    <Dialog className="history-dialog" onClose={props.close} isOpen={props.isOpen}>
      <HTMLTable>
        <thead>
          <tr>
            <th>Event</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>{body}</tbody>
      </HTMLTable>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button intent={Intent.PRIMARY} onClick={props.close}>
            Close
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
